import { slicedToArray as _slicedToArray, objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useState } from 'react';
import { formattingLogData } from '@bucketplace/bucket-log';
import '@emotion/react';
import '../contexts/internal/StickyContext.js';
import '../contexts/internal/EditorContext.js';
import { useEditorInfoContext } from '../contexts/external/EditorInfoContext.js';
import { useIntersectionObserver } from './useIntersectionObserver.js';

var _excluded = ["category"];
function useImpressionLog(_ref) {
  var logData = _ref.logData,
    threshold = _ref.threshold,
    disable = _ref.disable;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    ref = _useState2[0],
    setRef = _useState2[1];
  var _useEditorInfoContext = useEditorInfoContext(),
    onSendLog = _useEditorInfoContext.onSendLog;
  var sendImpressionLog = function sendImpressionLog() {
    if (isIntersecting && !disable && !!logData) {
      logData.category;
        var others = _objectWithoutProperties(logData, _excluded);
      onSendLog === null || onSendLog === void 0 || onSendLog({
        category: 'impression',
        data: [_objectSpread2(_objectSpread2({}, formattingLogData(others)), {}, {
          time: Date.now()
        })]
      });
    }
  };
  var isIntersecting = useIntersectionObserver({
    target: ref,
    options: {
      threshold: threshold
    },
    onIntersect: sendImpressionLog
  });
  return {
    ref: setRef
  };
}

export { useImpressionLog };
//# sourceMappingURL=useImpressionLog.js.map
